/*
  PLP filter drawer — behaviour for the Figma redesign of the facets modal.

  Two jobs, both handled with delegated listeners because `facets.js`
  re-renders `.js-filter` groups and `.active-facets-desktop` in place after
  every filter change:

  1. Sort. The drawer renders an "Ordenar por" radio group named `sort_by`,
     the same name as Madrid's `#SortBy` select in the results bar. Both live
     inside `#FacetFiltersForm`, and `FacetFiltersForm.onSubmitHandler` treats
     `sort_by` as a single-value key (`URLSearchParams.set`), so the last one
     in DOM order wins — the radios. Keeping the two in sync in both
     directions means it does not matter which one wins.

  2. "Filtrar" closes the drawer. Filtering is already live (the form submits
     on input, debounced), so the button only has to dismiss the panel, using
     the same class/flag dance as the close button in `facets.js`.
*/

(function () {
  'use strict';

  var DRAWER = '.facets__container--drawer';
  var SORT_RADIO = DRAWER + ' input[type="radio"][name="sort_by"]';
  var SORT_SELECT = 'select[name="sort_by"]';

  function matches(element, selector) {
    return element && element.nodeType === 1 && element.matches(selector);
  }

  function syncSelectsFromRadio(radio) {
    document.querySelectorAll(SORT_SELECT).forEach(function (select) {
      if (select.value !== radio.value) select.value = radio.value;
    });
  }

  function syncRadiosFromSelect(select) {
    document.querySelectorAll(SORT_RADIO).forEach(function (radio) {
      radio.checked = radio.value === select.value;
    });
  }

  // Capture phase: runs before the `input` listener `facets.js` binds on the
  // form, so the merged FormData is already consistent when it submits.
  document.addEventListener(
    'input',
    function (event) {
      var target = event.target;
      if (matches(target, SORT_RADIO)) {
        syncSelectsFromRadio(target);
      } else if (matches(target, SORT_SELECT)) {
        syncRadiosFromSelect(target);
      }
    },
    true
  );

  function closeDrawer(container) {
    if (!container) return;
    container.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () {
      document.body.classList.remove('filter-open');
    }, 700);
  }

  document.addEventListener('click', function (event) {
    var apply = event.target.closest && event.target.closest('.js-facets-apply');
    if (!apply) return;
    event.preventDefault();
    closeDrawer(apply.closest('.facets__container'));
  });

  // The server re-renders the sort group with the right `checked` value, but
  // the select is re-rendered by a different code path; realign after each
  // filter response so the two never drift.
  document.addEventListener('DOMContentLoaded', function () {
    var select = document.querySelector(SORT_SELECT);
    if (select) syncRadiosFromSelect(select);
  });
})();
